/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { ClassificationService } from './services/ClassificationService';
import { HealthService } from './services/HealthService';
import { ImageEmbeddingService } from './services/ImageEmbeddingService';
import { LoaderService } from './services/LoaderService';
import { PredictionService } from './services/PredictionService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class EmbeddyCrockerAPIClient {

    public readonly classification: ClassificationService;
    public readonly health: HealthService;
    public readonly imageEmbedding: ImageEmbeddingService;
    public readonly loader: LoaderService;
    public readonly prediction: PredictionService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.classification = new ClassificationService(this.request);
        this.health = new HealthService(this.request);
        this.imageEmbedding = new ImageEmbeddingService(this.request);
        this.loader = new LoaderService(this.request);
        this.prediction = new PredictionService(this.request);
    }
}

